import DeprecClassRecalcForm from './DeprecClassRecalcForm'
export default DeprecClassRecalcForm
